/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type NotFoundResult,
    NotFoundResultFromJSON,
    NotFoundResultToJSON,
} from '../models/NotFoundResult';
import {
    type PermissionResponse,
    PermissionResponseFromJSON,
    PermissionResponseToJSON,
} from '../models/PermissionResponse';
import {
    type RoleResponse,
    RoleResponseFromJSON,
    RoleResponseToJSON,
} from '../models/RoleResponse';
import {
    type SectionDetailResponse,
    SectionDetailResponseFromJSON,
    SectionDetailResponseToJSON,
} from '../models/SectionDetailResponse';
import {
    type SectionDetailResponsePagedResult,
    SectionDetailResponsePagedResultFromJSON,
    SectionDetailResponsePagedResultToJSON,
} from '../models/SectionDetailResponsePagedResult';
import {
    type SectionPermissionsUpdateRequest,
    SectionPermissionsUpdateRequestFromJSON,
    SectionPermissionsUpdateRequestToJSON,
} from '../models/SectionPermissionsUpdateRequest';
import {
    type SectionRolesUpdateRequest,
    SectionRolesUpdateRequestFromJSON,
    SectionRolesUpdateRequestToJSON,
} from '../models/SectionRolesUpdateRequest';
import {
    type SectionSearchOrderBy,
    SectionSearchOrderByFromJSON,
    SectionSearchOrderByToJSON,
} from '../models/SectionSearchOrderBy';
import {
    type SortOrder,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models/SortOrder';

export interface ApiSectionsGetRequest {
    pageNumber?: any;
    pageSize?: any;
    sortOrder?: SortOrder;
    orderField?: SectionSearchOrderBy;
    filter?: string;
}

export interface ApiSectionsSectionCodeGetRequest {
    sectionCode: string;
}

export interface ApiSectionsSectionCodePermissionsGetRequest {
    sectionCode: string;
}

export interface ApiSectionsSectionCodePermissionsPutRequest {
    sectionCode: string;
    sectionPermissionsUpdateRequest: SectionPermissionsUpdateRequest;
}

export interface ApiSectionsSectionCodeRolesGetRequest {
    sectionCode: string;
}

export interface ApiSectionsSectionCodeRolesPutRequest {
    sectionCode: string;
    sectionRolesUpdateRequest: SectionRolesUpdateRequest;
}

/**
 * 
 */
export class SectionsApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiSectionsGet without sending the request
     */
    async apiSectionsGetRequestOpts(requestParameters: ApiSectionsGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['PageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['SortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['orderField'] != null) {
            queryParameters['OrderField'] = requestParameters['orderField'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/sections`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiSectionsGetRaw(requestParameters: ApiSectionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SectionDetailResponsePagedResult>> {
        const requestOptions = await this.apiSectionsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SectionDetailResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiSectionsGet(requestParameters: ApiSectionsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SectionDetailResponsePagedResult> {
        const response = await this.apiSectionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiSectionsSectionCodeGet without sending the request
     */
    async apiSectionsSectionCodeGetRequestOpts(requestParameters: ApiSectionsSectionCodeGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['sectionCode'] == null) {
            throw new runtime.RequiredError(
                'sectionCode',
                'Required parameter "sectionCode" was null or undefined when calling apiSectionsSectionCodeGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/sections/{sectionCode}`;
        urlPath = urlPath.replace('{sectionCode}', encodeURIComponent(String(requestParameters['sectionCode'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiSectionsSectionCodeGetRaw(requestParameters: ApiSectionsSectionCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SectionDetailResponse>> {
        const requestOptions = await this.apiSectionsSectionCodeGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SectionDetailResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiSectionsSectionCodeGet(requestParameters: ApiSectionsSectionCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SectionDetailResponse> {
        const response = await this.apiSectionsSectionCodeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiSectionsSectionCodePermissionsGet without sending the request
     */
    async apiSectionsSectionCodePermissionsGetRequestOpts(requestParameters: ApiSectionsSectionCodePermissionsGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['sectionCode'] == null) {
            throw new runtime.RequiredError(
                'sectionCode',
                'Required parameter "sectionCode" was null or undefined when calling apiSectionsSectionCodePermissionsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/sections/{sectionCode}/permissions`;
        urlPath = urlPath.replace('{sectionCode}', encodeURIComponent(String(requestParameters['sectionCode'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiSectionsSectionCodePermissionsGetRaw(requestParameters: ApiSectionsSectionCodePermissionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PermissionResponse>>> {
        const requestOptions = await this.apiSectionsSectionCodePermissionsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PermissionResponseFromJSON));
    }

    /**
     */
    async apiSectionsSectionCodePermissionsGet(requestParameters: ApiSectionsSectionCodePermissionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PermissionResponse>> {
        const response = await this.apiSectionsSectionCodePermissionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiSectionsSectionCodePermissionsPut without sending the request
     */
    async apiSectionsSectionCodePermissionsPutRequestOpts(requestParameters: ApiSectionsSectionCodePermissionsPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['sectionCode'] == null) {
            throw new runtime.RequiredError(
                'sectionCode',
                'Required parameter "sectionCode" was null or undefined when calling apiSectionsSectionCodePermissionsPut().'
            );
        }

        if (requestParameters['sectionPermissionsUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'sectionPermissionsUpdateRequest',
                'Required parameter "sectionPermissionsUpdateRequest" was null or undefined when calling apiSectionsSectionCodePermissionsPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/sections/{sectionCode}/permissions`;
        urlPath = urlPath.replace('{sectionCode}', encodeURIComponent(String(requestParameters['sectionCode'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SectionPermissionsUpdateRequestToJSON(requestParameters['sectionPermissionsUpdateRequest']),
        };
    }

    /**
     */
    async apiSectionsSectionCodePermissionsPutRaw(requestParameters: ApiSectionsSectionCodePermissionsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>> {
        const requestOptions = await this.apiSectionsSectionCodePermissionsPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiSectionsSectionCodePermissionsPut(requestParameters: ApiSectionsSectionCodePermissionsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<any>> {
        const response = await this.apiSectionsSectionCodePermissionsPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiSectionsSectionCodeRolesGet without sending the request
     */
    async apiSectionsSectionCodeRolesGetRequestOpts(requestParameters: ApiSectionsSectionCodeRolesGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['sectionCode'] == null) {
            throw new runtime.RequiredError(
                'sectionCode',
                'Required parameter "sectionCode" was null or undefined when calling apiSectionsSectionCodeRolesGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/sections/{sectionCode}/roles`;
        urlPath = urlPath.replace('{sectionCode}', encodeURIComponent(String(requestParameters['sectionCode'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiSectionsSectionCodeRolesGetRaw(requestParameters: ApiSectionsSectionCodeRolesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RoleResponse>>> {
        const requestOptions = await this.apiSectionsSectionCodeRolesGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RoleResponseFromJSON));
    }

    /**
     */
    async apiSectionsSectionCodeRolesGet(requestParameters: ApiSectionsSectionCodeRolesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RoleResponse>> {
        const response = await this.apiSectionsSectionCodeRolesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiSectionsSectionCodeRolesPut without sending the request
     */
    async apiSectionsSectionCodeRolesPutRequestOpts(requestParameters: ApiSectionsSectionCodeRolesPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['sectionCode'] == null) {
            throw new runtime.RequiredError(
                'sectionCode',
                'Required parameter "sectionCode" was null or undefined when calling apiSectionsSectionCodeRolesPut().'
            );
        }

        if (requestParameters['sectionRolesUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'sectionRolesUpdateRequest',
                'Required parameter "sectionRolesUpdateRequest" was null or undefined when calling apiSectionsSectionCodeRolesPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/sections/{sectionCode}/roles`;
        urlPath = urlPath.replace('{sectionCode}', encodeURIComponent(String(requestParameters['sectionCode'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SectionRolesUpdateRequestToJSON(requestParameters['sectionRolesUpdateRequest']),
        };
    }

    /**
     */
    async apiSectionsSectionCodeRolesPutRaw(requestParameters: ApiSectionsSectionCodeRolesPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>> {
        const requestOptions = await this.apiSectionsSectionCodeRolesPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiSectionsSectionCodeRolesPut(requestParameters: ApiSectionsSectionCodeRolesPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<any>> {
        const response = await this.apiSectionsSectionCodeRolesPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
